import * as yup from 'yup';
import i18next from 'i18next';

function getGroupAddValidationSchema() {
  return yup.object({
    groupid: yup
      .number()
      .positive(i18next.t('validation.groupAdd.groupId.positive'))
      .integer(i18next.t('validation.groupAdd.groupId.integer'))
      .required(i18next.t('validation.groupAdd.groupId.required')),
    type: yup
      .string()
      .oneOf(['gallery', 'collection'], i18next.t('validation.groupAdd.type.oneOf'))
      .required(i18next.t('validation.groupAdd.type.required')),
    folderid: yup
      .number()
      .positive(i18next.t('validation.groupAdd.folderId.positive'))
      .integer(i18next.t('validation.groupAdd.folderId.integer'))
      .required(i18next.t('validation.groupAdd.folderId.required')),
    deviationid: yup
      .number()
      .positive(i18next.t('validation.groupAdd.deviationId.positive'))
      .integer(i18next.t('validation.groupAdd.deviationId.integer'))
      .required(i18next.t('validation.groupAdd.deviationId.required')),
  });
}

/**
 * Validates group add request data using Yup schema
 * Based on papiRequestDaDeviationGroupAddSchema
 * @param data The request data to validate
 * @returns boolean indicating if validation passed
 */
export function validateGroupAddRequest(data: any): boolean {
  try {
    getGroupAddValidationSchema().validateSync(data, { abortEarly: false });
    return true;
  } catch {
    return false;
  }
}
